export function initMenuHeader() {
    const BREAKPOINT = 991;

    const menuItems = document.querySelectorAll<HTMLElement>(
        '.header-menu__item_drop'
    );

    const isMobile = () => window.innerWidth < BREAKPOINT;

    function setupState() {
        menuItems.forEach((item) => {
            const submenu = item.querySelector<HTMLElement>('.dop-menu');
            if (!submenu) return;

            if (isMobile()) {
                submenu.style.overflow = 'hidden';
                submenu.style.height = '0px';
                submenu.style.transition = 'height 0.3s ease';
            } else {
                item.classList.remove('active');
                submenu.style.height = '';
                submenu.style.overflow = '';
                submenu.style.transition = '';
            }
        });
    }

    setupState();

    menuItems.forEach((item) => {
        const link = item.querySelector<HTMLAnchorElement>('.header-menu__link');
        const submenu = item.querySelector<HTMLElement>('.dop-menu');

        if (!link || !submenu) return;

        link.addEventListener('click', (e) => {
            if (!isMobile()) return;

            e.preventDefault();

            const isActive = item.classList.contains('active');

            if (isActive) {
                submenu.style.height = submenu.scrollHeight + 'px';

                requestAnimationFrame(() => {
                    submenu.style.height = '0px';
                });

                item.classList.remove('active');
            } else {
                item.classList.add('active');
                submenu.style.height = submenu.scrollHeight + 'px';
            }
        });
    });

    window.addEventListener('resize', setupState);
}
